import React from 'react'
import type { Campaign } from '@mobi/account/Areas/SignUp'
import { getCampaignRaceUrl } from '@mobi/account/Utils'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { openDeposit } from '@core/Areas/Deposit'
import { MainContainer } from '@core/Components/Containers'
import { fetchCampaignsAsync } from '@core/State/UserAccount/async-signals'
import { appHistory } from '@core/Utils/routing/history'
import { BetOffers } from './Components/BetOffers'

export const BonusesPage: React.FC = () => {
  React.useEffect(() => {
    fetchCampaignsAsync()
  }, [])

  const handleCampaignClick = (campaign: Campaign) => {
    if (campaign.triggerType === 'AccountDepositTrigger' && campaign.isLive) openDeposit()
    else appHistory.push(getCampaignRaceUrl(campaign))
  }

  return (
    <MainContainer data-tid-bonus-detail-heading background='surface300'>
      <PageHeader title='Bonuses' />
      <BetOffers handleCampaignClick={handleCampaignClick} />
    </MainContainer>
  )
}
